import { render, staticRenderFns } from "./EmergencyTransportPatientSetting.vue?vue&type=template&id=f537181a&scoped=true&lang=pug"
import script from "./EmergencyTransportPatientSetting.vue?vue&type=script&lang=ts"
export * from "./EmergencyTransportPatientSetting.vue?vue&type=script&lang=ts"
import style0 from "./EmergencyTransportPatientSetting.vue?vue&type=style&index=0&id=f537181a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f537181a",
  null
  
)

export default component.exports